// DF-515: imported first in main.tsx, so the clock is shifted before any
// other module reads it.
import { installTimeTravel } from '@/utils/timeTravel'

installTimeTravel()
